import { useQuery } from '@apollo/client/react';
import { bookingQuery } from '../../use-cases/manage/details/graphql/bookingQuery';

export const useBasicBooking = (bookingNo: number) => {
  const { data, loading, error } = useQuery(bookingQuery, {
    fetchPolicy: 'network-only',
    variables: { bookingNo },
  });

  return {
    booking: data?.viewer?.bookings?.booking ?? null,
    loading: loading || (data && !data.viewer) || false,
    error,
  };
};
